<section
  class="flex h-full w-full flex-col overflow-hidden bg-white text-gray-900"
  role="dialog"
  [attr.aria-label]="'board_v3_contact_link_existing' | translate"
>
  <header class="flex shrink-0 items-center gap-3 border-b border-gray-100 px-4 py-3">
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
      <app-icon>person_search</app-icon>
    </div>
    <div class="min-w-0 flex-1">
      <h2 class="m-0 text-base font-bold leading-6 text-gray-900">
        {{ 'board_v3_contact_link_existing' | translate }}
      </h2>
    </div>
    <button
      type="button"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100"
      [attr.aria-label]="'close' | translate"
      (click)="onCancel()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  <div class="flex shrink-0 flex-col gap-2 border-b border-gray-100 px-4 py-3">
    <div class="relative">
      <app-icon
        class="pointer-events-none absolute left-3 top-1/2 !h-5 !w-5 -translate-y-1/2 !text-[20px] !leading-5 text-gray-400"
      >
        search
      </app-icon>
      <input
        type="search"
        class="block h-11 w-full rounded-lg border border-gray-200 bg-white py-2 pl-10 pr-3 text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:border-blue-400"
        [ngModel]="search"
        (ngModelChange)="onSearchChange($event)"
        [placeholder]="'board_v3_contact_search_placeholder' | translate"
      />
    </div>
    <button
      type="button"
      class="flex items-center gap-1 self-start text-sm font-semibold text-blue-500 hover:text-blue-600"
      (click)="onCreate()"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">person_add</app-icon>
      {{ 'board_v3_contact_create_new' | translate }}
    </button>
  </div>

  <div class="crm-scroll min-h-0 flex-1 overflow-y-auto px-2 py-2" (scroll)="onScroll($event)">
    @if (loading) {
      <div class="flex h-full min-h-48 items-center justify-center">
        <app-loader />
      </div>
    } @else {
      @for (contact of contacts; track contact.id) {
        <button
          type="button"
          class="flex w-full min-w-0 items-center gap-3 rounded-lg px-3 py-2 text-left transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent"
          [disabled]="isExcluded(contact)"
          (click)="onSelect(contact)"
        >
          <app-avatar [title]="getContactName(contact)" size="36px" [isPhotoGallery]="false" />
          <span class="min-w-0 flex-1">
            <span class="block truncate text-sm font-semibold text-gray-900">{{ getContactName(contact) }}</span>
            <span class="block truncate text-xs text-gray-500">
              @for (phone of getContactPhones(contact); track phone; let last = $last) {
                {{ formatContactPhone(phone) }}{{ last ? '' : ', ' }}
              }
              @if (getContactPhones(contact).length && getContactEmails(contact).length) {
                ·
              }
              {{ getContactEmails(contact).join(', ') }}
            </span>
          </span>
          @if (isExcluded(contact)) {
            <span class="shrink-0 text-xs font-medium text-gray-400">{{
              'board_v3_contact_already_linked' | translate
            }}</span>
          }
        </button>
      } @empty {
        <div
          class="flex h-full min-h-48 flex-col items-center justify-center rounded-xl bg-gray-50 px-4 py-8 text-center"
        >
          <app-icon class="mb-2 !text-[28px] text-gray-300">search_off</app-icon>
          <p class="m-0 text-sm font-medium text-gray-600">{{ 'board_v3_contacts_empty' | translate }}</p>
        </div>
      }

      @if (loadingMore) {
        <app-loader type="indeterminate" />
      }
    }
  </div>
</section>
